/**
 * Minimal class name joiner. The components compose a handful of conditional Tailwind classes and
 * never need merge semantics, so this stays a four-line function instead of a dependency.
 */
export function cx(...parts: readonly (string | false | null | undefined)[]): string {
  return parts
    .filter((part): part is string => typeof part === 'string' && part.length > 0)
    .join(' ')
}
